import cloudinary from '@gilbarbara/cloudinary';
import { S3_BUCKET_URL } from '@/constants';

const cl = cloudinary({ cloudName: 'gravalot' });
const MAX_WIDTH = 3000;

// The standard sizes should be about 50 - 200px larger
// than the elements so that we can load a larger image
// and scale the image down for a higher quality output
const standardSizes = [150, 400, 800, 1200, 2000, MAX_WIDTH];

export default (src: string = '', width?: number) => {
  // only transform urls saved in s3 asset bucket
  if (!src.includes(S3_BUCKET_URL)) {
    return false;
  }

  // default to MAX_WIDTH if size is greater than expected – resulting image may be blurry
  // or undefined if not provided
  const closestWidth = width
    ? (standardSizes.find(size => width <= size) || MAX_WIDTH)
    : undefined;

  // replace s3 bucket root and with cloudinary directory
  // and return only keys required by transformation
  const srcPath = src.replace(S3_BUCKET_URL, '');
  return cl(`pleatt${srcPath}`, {
    ...closestWidth && {
      width: closestWidth,
    },
  });
};
